// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetProgramRequest {
    static getAttributeTypeMap() {
        return GetProgramRequest.attributeTypeMap;
    }
}
GetProgramRequest.discriminator = undefined;
GetProgramRequest.additionalProperties = false;
GetProgramRequest.attributeTypeMap = [
    {
        "name": "promotionId",
        "baseName": "promotionId",
        "type": "number"
    },
    {
        "name": "programCode",
        "baseName": "programCode",
        "type": "string"
    },
];
//# sourceMappingURL=getProgramRequest.js.map